/* eslint-disable @typescript-eslint/no-loop-func */
/* eslint-disable no-loop-func */
import moment from 'moment';
import { FilterProps } from 'pages/SalesOrder/types/salesOrder';
import { SalesOrderProps } from 'types/salesOrder';
// import { validArray } from 'utils';
import { SupplierId, WarehouseId } from 'pages/SalesOrder/config';

export function mutateFilters(filters: FilterProps) {
  const {
    // activityType,
    // date,
    // fromDate: stateFromDate,
    // date,
    fromDate,
    toDate,
    creationDate,
    limit,
    offSet,
    processingStatus,
    accountDescription,
    customerPONumber,
    sourceProductNumber,
    supplierSelectedNo,
    warehouseSelectedId,
    orgRef,
    // toDate: stateToDate,
  } = filters;
  // let fromDate;
  // let toDate;

  /* if (date === 'Past Day') {
    fromDate = moment().subtract(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  }

  if (date === 'Past Week') {
    fromDate = moment().subtract(6, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  }

  if (date === 'Past Month') {
    fromDate = moment().subtract(1, 'month').add(1, 'day').startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
  }

  if (date === 'Choose Dates') {
    fromDate = moment(stateFromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
    toDate = moment(stateToDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
  } */
  function getWarehouseId(name: string) {
    let id = null;
    for (const [key, items] of Object.entries(WarehouseId)) {
      if (orgRef === key) {
        items.forEach((item: { displayName: string, value: string }) => {
          if (name === item.displayName) {
            id = item.value
          }
        });
      }       
    }
    return id;
  }

  function getSupplierId(name: string[]) {
    let id: string[] = [];
    if (name.length === 0) {
      for (const [key, items] of Object.entries(SupplierId)) {
        if (orgRef === key) {
          items.forEach((item: { displayName: string, supplierId: string }) => {
            id.push(item.supplierId)
          });
        }       
      }
    } else {
      id = name;
    }
    return id.toString();
  }

  return {
    'supplierId[in]': supplierSelectedNo.length === 0 ? getSupplierId(supplierSelectedNo) : getSupplierId(supplierSelectedNo).slice(0, -1),
    packSite: warehouseSelectedId.includes('ALL') ? getWarehouseId('ALL') : warehouseSelectedId.slice(0, -1),
    PackId: sourceProductNumber,
    creationDate:creationDate ? moment(creationDate).startOf('day').format('YYYY-MM-DD') : '',
    customerDeliveryDateFrom: fromDate ? moment(fromDate).startOf('day').format('YYYY-MM-DD') : '',
    customerDeliveryDateTo: toDate ? moment(toDate).startOf('day').format('YYYY-MM-DD') : '',
    'processingStatus[in]': processingStatus ? processingStatus.join(',').toUpperCase() : null,
    purchaseOrderRef: customerPONumber,
    customerLocationId: accountDescription,
    limit,
    offSet,
  }
}

export function getSalesOrderCellData(salesOrder:SalesOrderProps) {
  const { 
    orderInfo: {
      createdDate, source, supplierId,
    },
    customer: {
      shipTo: {
        locationId,
      },
    },
  } = salesOrder;
  return [
    {
      label: 'Location ID',
      value: locationId,
    },
    {
      label: 'Supplier Id',
      value: supplierId,
    },
    {
      label: 'Created Date',
      value: moment(createdDate).format('DD MMM YYYY'),
    },
    {
      label: 'Order Source',
      value: source,
    },
  ]
}
